import {EscortAppPatientEnum} from "fragments";

export const dontAllowChangesLegStatuses = (status) => {
    const blockedStatuses = [EscortAppPatientEnum.CANCELLED, EscortAppPatientEnum.NO_SHOW]
    return blockedStatuses.includes(status);
}